import { BooleanFormType } from "Store/interfaces/FormTypes";
import { PregnantAndNewbornCoverage } from "Store/interfaces/products/coverage";

export const coverageTypeFrom = (
  childBorn: BooleanFormType | undefined,
  multipleChildren: BooleanFormType | undefined,
): PregnantAndNewbornCoverage => {
  if (childBorn === BooleanFormType.TRUE) {
    if (multipleChildren === BooleanFormType.TRUE) {
      return PregnantAndNewbornCoverage.NEWBORN_MULTIPLE_CHILDREN;
    }
    return PregnantAndNewbornCoverage.NEWBORN;
  }
  if (multipleChildren === BooleanFormType.TRUE) {
    return PregnantAndNewbornCoverage.PREGNANT_MULTIPLE_CHILDREN;
  }
  return PregnantAndNewbornCoverage.PREGNANT;
};
